import { useState } from "react";
import { faq } from "../../../constant/data";
import { IoChevronDownOutline, IoChevronUpSharp } from "react-icons/io5";

const FAQSection =()=>{
      const [selectedQuestion, setSelectedQuestion] = useState<string | null>(null);
    
      const toggleQuestion = (title: string) => {
        setSelectedQuestion((prev) => (prev === title ? null : title));
      };
    return (
          <section
          id="faq"
          className="bg-[#001D21] mt-20 py-20 px-4 sm:px-8 lg:px-20 rounded-tr-lg rounded-tl-lg"
        >
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
            <div className="w-full self-center">
              <h3 className="text-3xl lg:text-4xl md:text-start text-center text-[#D4F3D5] font-worksans text-stroke-hover leading-tight">
                Frequently asked
                <br />
                <span className="font-worksans">questions</span>
              </h3>
            </div>

            <ul className="w-full text-[#F8F8F8] space-y-4">
              {faq.map((q) => {
                const isOpen = selectedQuestion === q.title;
                return (
                  <li
                    key={q.title}
                    className="border-b border-[#2F4F4F] pb-2 transition-all duration-300 last:border-b-0"
                  >
                    <button
                      className="text-left w-full cursor-pointer flex justify-between items-center"
                      onClick={() => toggleQuestion(q.title)}
                    >
                      <h4 className="text-base sm:text-lg font-bold mb-1">
                        {q.title}
                      </h4>
                      {isOpen ? (
                        <IoChevronUpSharp className="w-5 h-5 text-stroke-hover" />
                      ) : (
                        <IoChevronDownOutline className="w-5 h-5 text-stroke-hover" />
                      )}
                    </button>
                    <div
                      className={`transition-all text-secondary-milk font-normal text-lg duration-300 ease-in-out overflow-hidden ${
                        isOpen
                          ? "max-h-[300px] opacity-100 mt-2"
                          : "max-h-0 opacity-0"
                      }`}
                    >
                      <div
                        className="text-sm sm:text-base [&_ul]:pl-5 [&_ul]:mt-2 [&_li]:mb-1 [&_li]:list-disc"
                        dangerouslySetInnerHTML={{ __html: q.description }}
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </section>
    )


}

export default FAQSection